/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyNumber: {
        id: 'cep.components.sgPolicyPaymentTile.PolicyNumber',
        defaultMessage: 'Policy number'
    },
    StartDate: {
        id: 'cep.components.sgPolicyPaymentTile.StartDate',
        defaultMessage: 'Start date'
    },
    ViewPayments: {
        id: 'cep.components.sgPolicyPaymentTile.ViewPayments',
        defaultMessage: 'View payments'
    },
    ViewMyInstrument: {
        id: 'cep.components.sgPolicyPaymentTile.ViewMyInstrument',
        defaultMessage: 'View my payment details'
    },
    CurrentPaymentDetails: {
        id: 'cep.components.sgPolicyPaymentTile.CurrentPaymentDetails',
        defaultMessage: 'Your current payment details'
    },
    ChangePaymentDetailsHeader: {
        id: 'cep.components.sgPolicyPaymentTile.ChangePaymentDetailsHeader',
        defaultMessage: 'Change your payment details'
    },
    BackToPayments: {
        id: 'cep.components.sgPolicyPaymentTile.BackToPayments',
        defaultMessage: 'Back to payments'
    },
    ChangeMyPaymentDetails: {
        id: 'cep.components.sgPolicyPaymentTile.ChangeMyPaymentDetails',
        defaultMessage: 'Change my payment details'
    },
    UpdateMyPaymentDetails: {
        id: 'cep.components.sgPolicyPaymentTile.UpdateMyPaymentDetails',
        defaultMessage: 'Update my payment details'
    },
    Cancel: {
        id: 'cep.components.sgPolicyPaymentTile.Cancel',
        defaultMessage: 'Cancel'
    },
    PaymentDate: {
        id: 'cep.components.sgPolicyPaymentTile.PaymentDate',
        defaultMessage: 'Payment date'
    },
    PaymentAmount: {
        id: 'cep.components.sgPolicyPaymentTile.PaymentAmount',
        defaultMessage: 'Payment amount'
    },
    Status: {
        id: 'cep.components.sgPolicyPaymentTile.Status',
        defaultMessage: 'Status'
    },
    InstalmentsToPayToggle: {
        id: 'cep.components.sgPolicyPaymentTile.InstalmentsToPayToggle',
        defaultMessage: 'Show instalments to pay: {amount}'
    },
    PaidInstalments: {
        id: 'cep.components.sgPolicyPaymentTile.PaidInstalments',
        defaultMessage: 'Show paid instalments: {amount}'
    },
    ArrearsHeader: {
        id: 'cep.components.sgPolicyPaymentTile.ArrearsHeader',
        defaultMessage: 'You have an outstanding payment'
    },
    Pay: {
        id: 'cep.components.sgPolicyPaymentTile.Pay',
        defaultMessage: 'Pay now'
    },
    InstalmentsToPay: {
        id: 'cep.components.sgPolicyPaymentTile.InstalmentsToPay',
        defaultMessage: 'Instalments to pay'
    },
    AmountToPay: {
        id: 'cep.components.sgPolicyPaymentTile.AmountToPay',
        defaultMessage: 'Amount to pay: {amount}'
    },
    CurrentPolicy: {
        id: 'cep.components.sgPolicyPaymentTile.CurrentPolicy',
        defaultMessage: 'Current policy'
    },
    Renewal: {
        id: 'cep.components.sgPolicyPaymentTile.Renewal',
        defaultMessage: 'Renewal'
    },
    SuccessfulPayment: {
        id: 'cep.components.sgPolicyPaymentTile.SuccessfulPayment',
        defaultMessage: 'Your payment has been successful'
    },
    UpdateDetailsNeeded: {
        id: 'cep.components.sgPolicyPaymentTile.UpdateDetailsNeeded',
        defaultMessage: 'If you need to update your card or bank details with us, you can do this by clicking on \'change my payment details\'.'
    },
    DetailsUpdated: {
        id: 'cep.components.sgPolicyPaymentTile.DetailsUpdated',
        defaultMessage: 'Your payment details have been updated successfully'
    },
    ChangePaymentDetailsTooltip: {
        id: 'cep.components.sgPolicyPaymentTile.ChangePaymentDetailsTooltip',
        defaultMessage: 'This policy is within the 30-day renewal period. To change your payment details, please review your renewal proposal or contact us via '
    },
    WebChatLink: {
        id: 'cep.components.sgPolicyPaymentTile.WebChatLink',
        defaultMessage: 'webchat.'
    }
});
